"use client";

import { HorizontalCategoricalBar } from "@/components/charts/HorizontalCategoricalBar";
import { getPalette, type PaletteToken } from "@/lib/palette";
import { usePrefersDark } from "@/lib/usePrefersDark";

export type BudgetRow = {
  category: string;
  ml_2027_2030: number;
  purpose: string;
};

type Props = {
  data: BudgetRow[];
};

const CATEGORY_TOKENS: Record<string, PaletteToken> = {
  "Accelerated Water Loss Program": "teal",
  "Advanced Meter Infrastructure": "cyan",
  "Other meter program": "slate",
  "Programs and policies": "violet",
};

export function BudgetChart({ data }: Props) {
  const p = getPalette(usePrefersDark());
  const max = Math.max(...data.map((d) => d.ml_2027_2030));
  const xMax = Math.ceil((max + 20) / 50) * 50;

  const rows = data.map((r) => ({
    label: r.category,
    value: r.ml_2027_2030,
    color: p[CATEGORY_TOKENS[r.category] ?? "teal"],
  }));

  return (
    <HorizontalCategoricalBar
      data={rows}
      height={288}
      valueDomain={[0, xMax]}
      xTickFormatter={(v) => `$${v}M`}
      valueLabelFormatter={(v) => `$${v}M`}
      tooltipLabel="2027-2030 budget"
      tooltipValueFormatter={(v) => `$${v}M`}
      categoryWidth={210}
    />
  );
}
